import { DailyEntriesTab } from "@/components/horoscope/DailyEntriesTab";
import { ZodiacSignsTab } from "@/components/horoscope/ZodiacSignsTab";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeft, Star } from "lucide-react";
import { Link } from "wouter";

export default function HoroscopePage() {
  return (
    <div
      className="p-6 space-y-6 max-w-6xl mx-auto"
      data-testid="horoscope-page"
    >
      <div className="flex items-center gap-4 flex-wrap">
        <Link href="/studio">
          <Button variant="ghost" size="icon" data-testid="button-back-studio">
            <ArrowLeft className="h-5 w-5" />
          </Button>
        </Link>
        <div className="flex items-center gap-2">
          <Star className="h-5 w-5 text-muted-foreground" />
          <h1
            className="font-serif text-2xl font-semibold text-foreground"
            data-testid="text-horoscope-title"
          >
            Horoscope
          </h1>
        </div>
      </div>

      <Tabs defaultValue="zodiac-signs" data-testid="horoscope-tabs">
        <TabsList data-testid="horoscope-tabs-list">
          <TabsTrigger value="zodiac-signs" data-testid="tab-zodiac-signs">
            Zodiac Signs
          </TabsTrigger>
          <TabsTrigger value="daily-entries" data-testid="tab-daily-entries">
            Add Horoscope
          </TabsTrigger>
        </TabsList>

        <TabsContent value="zodiac-signs">
          <ZodiacSignsTab />
        </TabsContent>

        <TabsContent value="daily-entries">
          <DailyEntriesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
